(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-default/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-default/assets/javascripts/init-box.js'); var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sportDefault = svs.themes.sportDefault || {};

  svs.themes.sportDefault.initStatusStart = function(data) {
    var s = data.status.id;

    if (
      !(s === 25 || s === 29 || s === 31 || s === 32 || s === 33 || s === 41) &&
      data.opt.date
    ) {
      return (
        '<div class="brick match-status brick-border f-condensed align-center">' +
        svs.themes.formatTime(data.startTime) +
        '</div>'
      );
    } else if (data.opt.date) {
      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
    }
    return '';
  };

  svs.themes.sportDefault.hasMatchMinutes = function() {
    return false;
  };
})(svs);

 })(window);